
import { sendDelete, sendGet, sendPost, sendPut } from "./generic";
import { getAssistantApiUrl, getNlpApiUrl } from "../../constants/Urls";
import VoicifyNlpResult from "../../models/nlp/VoicifyNlpResult";
import TestCase from "../../models/customAssistant/TestCase";
import AvailableTestCasesModel from "../../models/customAssistant/AvailableTestCasesModel";

// need to setup equivalent for:
/*

        [HttpDelete("{applicationId}")]
        [SwaggerResponse(200, type: typeof(TestCaseModel))]
        public async Task<IActionResult> DeleteTestCase(string applicationId, [FromQuery]string name, [FromQuery]string contentItemId)

        [HttpDelete("{applicationId}/deleteForContentItem")]
        [SwaggerResponse(200, type: typeof(List<TestCaseModel>))]   
        public async Task<IActionResult> DeleteTestCasesForContentItem(string applicationId, [FromQuery]string contentItemId)  

        for example:
        
        
        export const createUserTerm = (model: TermAgreementModel): Promise<IResult<UserTerm>> => {
            return sendPost(`/Term/agreement`, model);
        }

*/

/*
        [HttpGet("{applicationId}/loadTestCase")]
        [SwaggerResponse(200, type: typeof(TestCaseModel))]
        public async Task<IActionResult> GetTestCase(string applicationId, [FromQuery]string name, [FromQuery]string contentItemId) */
export const getTestCase = (applicationId: string, name: string, contentItemId: string) => {
    var url = `/TestCase/${applicationId}/loadTestCase`;
    if (name?.length) {
        url += `?name=${name}`;
    }
    if (contentItemId?.length) {
        if (url.indexOf("?") === -1) {
            url += "?";
        } else {
            url += "&";
        }
        url += `&contentItemId=${contentItemId}`;
    }

    return sendGet<TestCase>(url);
}

export const getTestCases = (applicationId: string, contentItemId: string, includeContentItemTestCases: boolean) => {
    var url = `/TestCase/${applicationId}/loadTestCases`;
    if (contentItemId?.length) {
        url += `?contentItemId=${contentItemId}`;
    }
    if (includeContentItemTestCases) {
        if (url.indexOf("?") === -1) {
            url += "?";
        } else {
            url += "&";
        }
        url += `&includeContentItemTestCases=${includeContentItemTestCases}`;
    }

    return sendGet<AvailableTestCasesModel>(url);
}

export const createTestCase = (applicationId: string, model: TestCase) => {
    return sendPost<TestCase>(`/TestCase/${applicationId}`, model);
}

export const updateTestCase = (applicationId: string, model: TestCase) => {
    return sendPut<TestCase>(`/TestCase/${applicationId}`, model);
}

export const deleteTestCase = (applicationId: string, name: string, contentItemId: string) => {
    const query: string[] = [];
    if (name?.length) {
        query.push(`name=${encodeURIComponent(name)}`);
    }
    if (contentItemId?.length) {
        query.push(`contentItemId=${encodeURIComponent(contentItemId)}`);
    }

    return sendDelete<TestCase>(`/TestCase/${applicationId}${query.length ? `?${query.join("&")}` : ""}`);
}

export const deleteTestCasesForContentItem = (applicationId: string, contentItemId: string) => {
    var url = `/TestCase/${applicationId}/deleteForContentItem`;
    if (contentItemId?.length) {
        url += `?contentItemId=${contentItemId}`;
    }

    return sendDelete<string[]>(url);
}
